import { useEffect, useState } from "react";
import axios from "axios";
import { API, useAuth } from "../App";
import { ShieldCheck, Users } from "lucide-react";

export const SCOPED_ROLES = ["sector_head_poly", "sector_head_mono", "composition_president"];
export const ROLE_LABELS = {
  sector_head_poly: "Υπεύθυνος/η Προσδιορισμού Τομέα Πολυμελούς",
  sector_head_mono: "Υπεύθυνος/η Τομέα Δικαίου / Πρόεδρος Προσδιορισμού Μονομελούς",
  composition_president: "Πρόεδρος Πολυμελούς Σύνθεσης",
};
export const isScopedRole = (user) => SCOPED_ROLES.includes(user?.role);
export const isPresidentRole = (user) => user?.role === "composition_president";

export const useMyScope = () => {
  const { user } = useAuth();
  const [scope, setScope] = useState(null);
  useEffect(() => {
    if (!isScopedRole(user)) { setScope(null); return; }
    axios.get(`${API}/me/scope`).then(r => setScope(r.data)).catch(() => setScope(null));
  }, [user]);
  return scope;
};

// Μπάνερ εμβέλειας για Υπεύθυνο Τομέα / Πρόεδρο Σύνθεσης (Πινάκια, Ημερολόγιο Έδρας)
export const RoleScopeBanner = () => {
  const { user } = useAuth();
  const scope = useMyScope();
  if (!isScopedRole(user) || !scope?.scoped) return null;
  const president = scope.role === "composition_president";
  const empty = president ? !scope.composition : !(scope.sectors || []).some(s => (s.pinakio_labels || []).length);
  return (
    <div className={`rounded-lg border px-4 py-2.5 text-sm flex items-start gap-2 ${empty ? "border-amber-300 bg-amber-50 text-amber-900" : "border-violet-200 bg-violet-50 text-violet-950"}`}
         data-testid="role-scope-banner">
      {president ? <Users className="w-4 h-4 mt-0.5 shrink-0" /> : <ShieldCheck className="w-4 h-4 mt-0.5 shrink-0" />}
      <div className="min-w-0">
        <p className="font-semibold" data-testid="role-scope-label">{scope.role_label} · {scope.court_type}</p>
        {president ? (
          scope.composition
            ? <p data-testid="role-scope-composition">Σύνθεση «{scope.composition.label}» — {scope.composition.sector_number}ος Τομέας{scope.composition.sector_title ? ` (${scope.composition.sector_title})` : ""}. Εμφανίζονται μόνο οι δικάσιμοι στις οποίες έχει ανατεθεί η σύνθεσή σας.</p>
            : <p data-testid="role-scope-empty">Δεν έχει αντιστοιχιστεί Σύνθεση στον λογαριασμό σας — επικοινωνήστε με τον Διαχειριστή.</p>
        ) : (
          empty
            ? <p data-testid="role-scope-empty">Δεν έχουν οριστεί Τομείς/Πινάκια για τον λογαριασμό σας (Διαχείριση → Χρήστες / Τομείς → Πινάκια Τομέα).</p>
            : <p data-testid="role-scope-sectors">
                {(scope.sectors || []).map(s => `${s.sector_number}ος Τομέας${s.title ? ` (${s.title})` : ""}: ${(s.pinakio_labels || []).join(", ") || "—"}`).join(" · ")}
              </p>
        )}
      </div>
    </div>
  );
};

export default RoleScopeBanner;
